import {Navigate} from "react-router-dom";
import {useUserAccount} from "../../../hooks/useUserAccount.ts";

export const PublicHomePage = () => {

    const {userAccount} = useUserAccount();

    if (userAccount) {
        return <Navigate to={'/dashboard'}/>
    } else {
        return <Navigate to={'/sign-in'}/>;
    }

};
